import React from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import { EVENT_MATCH_STATUS_TYPES, MULTIPLE_SPORT_TYPES, VOLLEYBALL, TENNIS, ICE_HOCKEY, BASKETBALL, URL_MAP_BY_TYPE, SPORT_TYPE_BY_URL, HANDBALL } from 'Store/constants/sportTypes';
import { renderScoreStatus } from 'Utils/scoreDisplayHelper';

const getCurrentScores = (currentScore, overTime, event)=>{
  if (event?.sportType === BASKETBALL && overTime?.home) {
    return `${overTime.home}-${overTime.away}`;
  }
  return typeof currentScore?.home != 'undefined' &&  typeof currentScore?.away != 'undefined' ? `${currentScore.home}-${currentScore.away}` : '';
};


const ScoreCell = ({ eventScore: { scores, sportType, currentScore, overTime, matchStatus, penalty }, isLoading, currentScoreDisplay, event, loginStatus, tabType } ) => {
  const normalizedSportType = sportType === 'HANDBALL' ? HANDBALL : sportType;
  const sportId = SPORT_TYPE_BY_URL[URL_MAP_BY_TYPE[normalizedSportType]];
  const couponRowScoresClassName = classnames({
    'coupon-row__scores animated': true,
    fadeIn: !isLoading
  });
  const renderExtendScores = () => {
    if (event?.sportType === BASKETBALL || event?.sportType === 'E_BASKETBOL') return null; //dont render extendScores at basketball at coupons
    let extendScores = {
      home: null,
      away: null,
      title: null
    };
    if (penalty?.home && penalty?.away) {
      extendScores.home = penalty.home;
      extendScores.away = penalty.away;
      extendScores.title = 'Pen.';

    } else if (overTime?.home && overTime?.away) {
      extendScores.home = overTime.home;
      extendScores.away = overTime.away;
      extendScores.title = 'Uzt.';
    }
    return (
      extendScores.title !== null ? <span className="coupon-row__scores coupon-row__scores--extend">{ `(${extendScores.title} ${extendScores.home}-${extendScores.away})` }</span> : null
    );
  };

  const renderTimePeriod = () => {
    if (MULTIPLE_SPORT_TYPES.FOOTBALL.includes(normalizedSportType) || normalizedSportType === 'E_FUTBOL' || normalizedSportType === 'E_BASKETBOL') {
      return currentScore.time || currentScore.title || '';
    }
    return renderScoreStatus(currentScore, normalizedSportType, scores);
  };

  const blurry = loginStatus === false && (tabType !== 'won' && tabType !== 'odd' && tabType !== 'earning') ? ' blurry-text' : '';

  const isPlaying = EVENT_MATCH_STATUS_TYPES.PLAYING.includes(matchStatus);
  const showScores = loginStatus || ['won', 'odd', 'earning'].includes(tabType);

  if (isPlaying && showScores) {
    return (
      <div className={ couponRowScoresClassName }>
        <div className="coupon-row__scores__first">
          <div className={ `coupon-row__scores--current ${blurry}` }>
            { `${currentScore.home}-${currentScore.away}` }
          </div>
        </div>
        <div className="coupon-row__scores__last">
          <div className={ `coupon-row__scores--first-half coupon-row__scores--first-half--live ${blurry} ` }>
            { `${ currentScoreDisplay ? currentScoreDisplay : renderTimePeriod()}` }
          </div>
        </div>
      </div>
    );
  } else if (isPlaying && !loginStatus && !showScores) {
    return (
      <div className={ `coupon-row__market-date ${blurry}` }>
        { event?.eventDateString }
      </div>
    );
  } else if (EVENT_MATCH_STATUS_TYPES.PLAYED.includes(matchStatus)) {
    return (
      <div className={ couponRowScoresClassName }>
        <div className="coupon-row__scores__first">
          {
            currentScore && (
              <>
                <div className={ `coupon-row__scores coupon-row__scores--current ${blurry} ` }>
                  { renderExtendScores() }
                  { getCurrentScores(currentScore, overTime, event) }
                </div>
              </>
            )
          }
        </div>
        <div className="coupon-row__scores__last">
          { ([VOLLEYBALL, TENNIS, ICE_HOCKEY].includes(sportId) || sportId === undefined)
            ? <div>
              <span>{ currentScoreDisplay }</span>
              <span
                className={ `coupon-row__scores--first-half ${blurry} ` }>{ typeof currentScore?.home != 'undefined' && typeof currentScore?.away != 'undefined' ? '   MS' : '' }
              </span>
            </div>
            : (
              <>
                {
                  scores && Number.isInteger(scores.away) && Number.isInteger(scores.home) && scores.title ? (
                    <div className={ `coupon-row__scores--first-half ${blurry} ` }>
                      { `${currentScoreDisplay || ''} ${scores.title}:${scores.home}-${scores.away}` }
                    </div>
                  ) : null
                }
              </>
            ) }
        </div>
      </div>
    );
  } else {
    return null;
  }
};

ScoreCell.propTypes = {
  eventScore: PropTypes.object.isRequired,
  event: PropTypes.object,
  isLoading: PropTypes.bool,
  currentScoreDisplay: PropTypes.string,
  loginStatus: PropTypes.bool,
  tabType: PropTypes.string,
};

ScoreCell.defaultProps = {
  eventScore: {},
  isLoading: true,
  currentScoreDisplay: '',
  event: {},
  loginStatus: true,
  tabType: ''
};

export default ScoreCell;
